import { getTelemetryHostingConfig } from '@ms/yammer-telemetry-store';
import type { HostingEnvironment } from '@ms/yammer-telemetry-support';

export type Environment = 'Development' | 'Dogfood' | 'Microsoft' | 'Production';

const hostingEnvironmentToEnvironment: Record<HostingEnvironment, Environment> = {
  dev: 'Development',
  SDFV2: 'Dogfood',
  edog: 'Dogfood',
  prodbubble: 'Dogfood',
  Dogfood: 'Dogfood',
  dogfood: 'Dogfood',
  Microsoft: 'Microsoft',
  MSIT: 'Microsoft',
  PROD: 'Production',
  FirstRelease: 'Production',
  WW: 'Production',
};

type GetEnvironment = () => Environment;
export const getEnvironment: GetEnvironment = () => {
  const hostingConfig = getTelemetryHostingConfig();
  if (!hostingConfig) {
    return 'Production';
  }

  return hostingEnvironmentToEnvironment[hostingConfig.hostingEnvironment] || 'Production';
};
